import { makeStyles } from "@material-ui/core";
import Color from "../../../../../styles/Color";
import * as yup from "yup";

export const useStyles = makeStyles({
    imagePreview: {
        width: "100%",
        height: 130,
        objectFit: "contain",
        "&.md": {
            height: 150,
        },
    },
    boxClickuploadfile: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#ededed",
        transition: "all .25s",
        cursor: "pointer",
        "&:hover": {
            boxShadow: "2px 2px 10px #efefef",
            color: Color.primary,
        },
        "&.isDrang": {
            boxShadow: "2px 2px 20px #ededed",
            backgroundColor: Color.primary,
            color: "#fff",
        },
    },
    boxUpdateFile: {
        border: "1px solid #efefef",
    },
});

export const newsBannerSchema = yup.object({
    bannerStartDate: yup.string().required("Start Date is required."),
    bannerEndDate: yup.string().required("End Date is required."),
    bannerStatus: yup.boolean(),
});

export const initialBannerValues = {
    bannerImages: [],
    bannerStartDate: new Date(),
    bannerEndDate: new Date(),
    bannerStatus: true,
};
